<template>
    <div>
        <mt-loadmore :bottomDropText="options.bottomDropText" :bottomPullText="options.bottomPullText"
                     :top-method="loadTop" :bottom-method="loadBottom"
                     :bottom-all-loaded="!options.hasMore"
                     ref="loadmore">
            <div class="list">
                <div v-for="item in list" class="list-item space-between" style="align-items: flex-start">
                    <div class="head-icon">
                        <img v-if="item.headImgUrl" :src="item.headImgUrl" style="width: 100%;height:100%;"/>
                        <img v-else src="../assets/img/default_head.svg"/>
                    </div>
                    <div style="flex:1;margin-left: 15px">
                        <div class="space-between">
                            <div style="font-size:18px">{{item.name}}</div>
                            <div style="flex:1;margin-left: 5px;color:#999">{{position[item.position * 1 - 1].label}}
                            </div>
                            <!--<img src="../assets/img/next.svg"/>-->
                        </div>
                        <div style="color:#555" v-html="item.detail"></div>
                    </div>
                </div>
            </div>
        </mt-loadmore>
    </div>
</template>

<script>
    import api from "../api";
    import utils from "../common/utils";
    import {Indicator} from 'mint-ui';

    export default {
        data() {
            return {
                options: {
                    currentPage: 1,
                    pageSize: 10,
                    hasMore: false,
                    bottomDropText: "释放加载",
                    bottomPullText: "加载更多",
                },
                list: [],
                position: [{
                    "value": 1,
                    "label": "主任医师"
                }, {
                    "value": 2,
                    "label": "副主任医师"
                }, {
                    "value": 3,
                    "label": "主治医师"
                }, {
                    "value": 4,
                    "label": "执业医师"
                }, {
                    "value": 5,
                    "label": "护士"
                }, {
                    "value": 6,
                    "label": "前台"
                }, {
                    "value": 7,
                    "label": "其他"
                }, {
                    "value": 8,
                    "label": "院长"
                }, {
                    "value": 9,
                    "label": "主任"
                }]
            }
        },
        methods: {
            loadTop: function () {
                this.options.currentPage = 1;
                this.loadList((res) => {
                    this.$refs.loadmore.onTopLoaded();
                });
            },
            loadBottom: function () {
                this.options.loading = true;
                this.options.currentPage++;
                this.loadList((res) => {
                    this.$refs.loadmore.onBottomLoaded();
                });
            },
            loadList: function (onload) {
                Indicator.open('加载中...');
                window.Indicator = Indicator;
                api.getFormUrl(this, "yy/front/getPersonList", {
                    pageNo: this.current,
                    pageSize: 15
                }, (res) => {
                    if (this.options.currentPage == 1) {
                        this.list = [];
                    }
                    this.list = this.list.concat(res.data)
                    if (res.total <= res.pageNo * res.pageSize) {
                        this.options.hasMore = false;
                        this.options.bottomPullText = "没有更多了";
                    } else {
                        this.options.hasMore = true;
                        this.options.bottomPullText = "加载更多";
                    }
                    onload(res);
                    Indicator.close();
                }, () => {
                    Indicator.close();
                })
            },
        },
        mounted() {
            setTimeout(() => {
                document.querySelector(".page-content").scrollTop = 0;
            },100)
        }
    }

</script>

<style lang="scss">
    @import "../assets/styles/common.css";

    .head-icon {
        width: 50px;
        height: 50px;
        border-radius: 100px;
        border: 1px solid #000;
        padding: 8px;
        box-sizing: border-box;
        margin-top: 6px;
    }

    .list {
        height: 100%;
    }

    .list-item {
        background: white;
        padding: 15px;
        margin-top: 7px;
    }

</style>